import styled from 'styled-components'

const Container = styled.div`
  padding-top: 1px;
  padding-bottom: 1px;
`
export default Container
